export default __webpack_public_path__ + "static/NSDC-8c28a02e301190b0ad989973ca882c00.png";